'use client'
import * as React from 'react'
import { tw } from 'utils/classnames'
import { useTranslations } from 'next-intl'

export function FooterDescription({ description }: { description: string }) {
  const t = useTranslations('pages.fonts.landing_page')
  const [isExpanded, setIsExpanded] = React.useState(false)
  return (
    <div className="flex flex-col mt-[60px] mb-[80px]">
      <style>{`
          .footer-description h2 {
              font-size: 24px;
              font-weight: 600;
              line-height: 1.3;
          }
  
          .footer-description strong {
            font-weight: 700;
          }
  
          .footer-description a {
            color: #3ab561;
          }
  
          .footer-description a:hover {
            color: #248142;
          }
        `}</style>
      <div
        className={tw('footer-description whitespace-pre-line', !isExpanded && 'line-clamp-5')}
        dangerouslySetInnerHTML={{ __html: description ?? '' }}
      />
      <button
        className="self-end underline text-12 text-[#7b898d]"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? t('read_less') : t('read_more')}
      </button>
    </div>
  )
}
